import { makeStyles } from '@material-ui/core';
import { colorSet } from '@components/Provider';

export const useStyles = makeStyles((theme) => ({
  root: {
    width: 690,
    gap: '24px',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      gap: 0
    }
  },
  mainTitle: {
    ...theme.typography.h2,
    fontWeight: 500,
    color: colorSet.gray900,
    marginBottom: 12,
    [theme.breakpoints.down('md')]: {
      ...theme.typography.h3,
      fontWeight: 500
    }
  },
  // subTitle: {
  //   ...theme.typography.body1,
  //   fontWeight: 400,
  //   color: colorSet.gray600,
  //   marginBottom: 4,
  //   [theme.breakpoints.down('md')]: {
  //     ...theme.typography.body2,
  //     fontWeight: 400,
  //     color: colorSet.gray700,
  //     padding: `24px 16px 40px 16px`,
  //     borderBottom: `1px solid ${colorSet.gray200}`,
  //     marginTop: '49px'
  //   }
  // },
  subHeader: {
    height: '49px',
    borderBottom: `1px solid ${colorSet.gray400}`
  },
  subHeaderTitle: {
    ...theme.typography.body1,
    fontWeight: 500,
    color: colorSet.gray900
  },
  box: {
    width: '100%',
    border: `1px solid ${colorSet.gray400}`,
    borderRadius: `8px`,
    [theme.breakpoints.down('md')]: {
      width: '100%',
      border: 0,
      borderRadius: 0
    },
    '&.doNotDisturb': {
      [theme.breakpoints.down('md')]: {
        marginTop: 49
      }
    }
  },
  titleBox: {
    margin: `24px 20px`,
    [theme.breakpoints.down('md')]: {
      margin: 0,
      padding: `24px 16px`
    }
  },
  warningBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '9px',
    marginTop: 16,
    width: '100%',
    padding: `8px 12px`,
    backgroundColor: `${colorSet.errorBackGround}`,
    borderRadius: 8
  },
  doNotDisturbBox: {
    width: 690,
    padding: `24px 20px`,
    [theme.breakpoints.down('md')]: {
      width: '100%',
      padding: `24px 16px`
    }
  },
  boxMainTitle: {
    fontSize: '20px',
    fontWeight: 500,
    color: colorSet.gray900,
    marginLeft: 11,
    [theme.breakpoints.down('md')]: {
      ...theme.typography.subtitle1,
      fontWeight: 500
    }
  },
  boxSubTitle: {
    marginTop: 8
  },
  switch: {
    '&.off': {
      '& .MuiSwitch-switchBase': {
        color: colorSet.gray400
      },
      '& .MuiSwitch-track': {
        backgroundColor: colorSet.gray500
      }
    }
  },
  switchStateTitle: {
    ...theme.typography.subtitle2,
    fontWeight: 400,
    color: colorSet.gray500,
    '&.on': {
      color: colorSet.primary500
    }
  },
  formControl: {
    width: '210px',
    '& .MuiOutlinedInput-input': {
      padding: `8px 14px`
    },
    [theme.breakpoints.down('md')]: {
      width: '200px'
    }
  },
  selectSubText: {
    ...theme.typography.body2,
    fontWeight: 400,
    marginLeft: 8
  },
  selectSubTextWave: {
    ...theme.typography.body2,
    fontWeight: 400,
    margin: `0px 8px`
  },
  select: {
    ...theme.typography.body1,
    fontWeight: 400,
    color: colorSet.gray900
  },
  menuPaper: {
    maxHeight: 305
  },

  boxDivider: {
    backgroundColor: colorSet.gray200,
    height: '12px'
  },
  titleDivider: {
    backgroundColor: colorSet.gray400,
    height: '1px',
    [theme.breakpoints.down('md')]: {
      backgroundColor: colorSet.gray200,
      width: '92%',
      margin: `auto`
    }
  }
}));
